import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  templateUrl: '403.component.html'
})
export class P403Component {

  constructor(
    private translate: TranslateService
  ) {
    this.translate.setDefaultLang('en-us');
  }

}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/shared/403.component.ts